import React from 'react';
import { Button, Spinner, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
  DueMonthlyWrapper,
  LabelDueMonthly,
  PricingBlockMain,
  BeforeTaxesLabel,
  DueNowWrapper,
  IntegralPart
} from './css';
import { formatCurrency } from '../../utils/currencyFormatter';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const getFormattedPricing = price => {
  return <IntegralPart>{formatCurrency(price)}</IntegralPart>;
};
const VulcanStatusBar = ({
  step,
  isLastStep,
  isFormTouched,
  onSaveAndExit,
  onProceedClick,
  onBackClick,
  totals,
  showDownloadQuoteFooter,
  onQuoteDownload,
  quotePdfStatus
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const locale = useLocaleContext();
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;
  const {
    vulcanWebform: { downloadQuotePdf, proceedWithOrder },
    ORDERS: { DUE_MONTHLY, DUE_NOW, BEFORE_TAXES }
  } = locale === 'en-US' ? EN : FR;
  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(totals.monthly < 0 ? 0 : totals.monthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(
                      totals.oneTime < 0 ? 0 : totals.oneTime
                    )}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
          <>
            {showDownloadQuoteFooter ? (
              <>
                <Spinner
                  label="Preparing PDF…"
                  variant={{ size: 'small' }}
                  show={quotePdfStatus === 'PREPARING'}
                  inline
                >
                  <Button
                    variant={{ priority: 'high' }}
                    type="button"
                    disabled={quotePdfStatus === 'PREPARING'}
                    onClick={onQuoteDownload}
                  >
                    {downloadQuotePdf}
                  </Button>
                </Spinner>
                {quotePdfStatus === 'FAILED' && (
                  <Typography variant={{ colour: 'error' }}>
                    Download failed — please try again.
                  </Typography>
                )}
                <Button
                  type="button"
                  onClick={e => onProceedClick(e)}
                  variant={{ priority: 'high' }}
                >
                  {proceedWithOrder}
                </Button>
              </>
            ) : (
              <>
                {step !== 1 && (
                  <Button
                    variant={{ priority: 'high' }}
                    type="button"
                    onClick={onBackClick}
                  >
                    {backLabel}
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    type="button"
                    onClick={e => onSaveAndExit(e)}
                    variant={{ priority: 'high' }}
                    disabled={!isFormTouched}
                  >
                    {saveContinueLaterButtonLabel}
                  </Button>
                )}
                <Button
                  type="button"
                  onClick={e => onProceedClick(e)}
                  variant={{ priority: 'high' }}
                >
                  {isLastStep ? submitButtonLabel : continueButtonLabel}
                </Button>
              </>
            )}
          </>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};
VulcanStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  totals: PropTypes.shape({
    oneTime: PropTypes.number,
    monthly: PropTypes.number
  }).isRequired,
  showDownloadQuoteFooter: PropTypes.bool.isRequired,
  onQuoteDownload: PropTypes.func.isRequired,
  quotePdfStatus: PropTypes.string
};

export default VulcanStatusBar;
